import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { COLORS } from "components/v3/Theme/colors";
import FormTemplateWrapper from "components/v3/sharedComponents/forms/FormTemplateWrapper";

interface TermsSheetProps {
  onClickContinue: () => void;
  formId: string;
  formTitle: string;
}

const TermsSheet: React.FC<TermsSheetProps> = ({
  onClickContinue,
  formId,
  formTitle
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [formId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        backgroundColor: COLORS.WHITE,
        borderRadius: "30px"
      }}
    >
      <Box
        sx={{
          width: "100%",
          padding: { xs: "42px 10px 10px", sm: "38px 28px 0px 10px" },
          boxSizing: "border-box"
        }}
      >
        <Typography
          variant="h5_serif"
          sx={{
            background: `linear-gradient(to right, ${COLORS.ACCENT3} 0%, ${COLORS.PRIMARY} 300%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}
          mb={2}
        >
          Terms of Use
        </Typography>
      </Box>

      <Box sx={{ width: "100%" }}>
        <FormTemplateWrapper formId={formId} onComplete={onClickContinue} />
      </Box>
    </Box>
  );
};

export default TermsSheet;
